import axios from 'axios'
import { addAccessTokenRequestInterceptor } from '../../auth/auth'

export const spacesApi = axios.create({
  baseURL: '/spaces/api',
})

addAccessTokenRequestInterceptor(spacesApi)
